import { Component } from 'react';
import PropTypes from 'prop-types';

/* Specific component for rows that match a risk class reduction year */
class TableRowRiskClassReductionComponent extends Component {
  render() {
    const { row, columnNames } = this.props;

    const cells = columnNames.map(key => (
      <td className="calculation-container__loanpart-overview__risk-class-reduction" key={key}>{row[key]}</td>
    ));

    return (
      <tr>
        {cells}
      </tr>
    );
  }
}

TableRowRiskClassReductionComponent.propTypes = {
  row: PropTypes.shape({}),
  columnNames: PropTypes.arrayOf(PropTypes.string),
};

TableRowRiskClassReductionComponent.defaultProps = {
  row: {},
  columnNames: [],
};

export default TableRowRiskClassReductionComponent;
